import type { OptionRef } from 'v5/core/entity-values/values.types';

/** Splits option refs into persisted ids and labels to create (tags / groups). */
export function splitOptionRefs(refs: OptionRef[]): {
  ids: number[];
  create: string[];
} {
  const ids: number[] = [];
  const create: string[] = [];
  for (const ref of refs) {
    if (ref.type === 'existing') {
      ids.push(ref.id);
    } else {
      create.push(ref.label);
    }
  }
  return { ids, create };
}
